// config/columns.ts
import { DEFAULT_COLUMN_WIDTH, COLUMN_SORT_ORDER, DEFAULT_COLUMNS_MAP } from './constants';
import type { ColumnDefinition, FieldDefinition, Renderer } from '../types';

/**
 * Build columns with renderers attached
 */
export function buildColumnsWithRenderers(
  fields: FieldDefinition[],
  trackingDateRenderer: Renderer,
  styledCellRenderer: Renderer,
  iSODateEditorWithContext: any,
): ColumnDefinition[] {
  const indexColumn = {
    data: 'id',
    title: 'ID',
    width: 0,
  };
  const columns = fields
    .filter((field) => COLUMN_SORT_ORDER.includes(field.key as any))
    .map((field) => {
      const baseConfig: ColumnDefinition = {
        data: field.key,
        title: field.label,
        width: DEFAULT_COLUMN_WIDTH,
        groups: field.groups ?? [],
      };

      const fieldConfig = DEFAULT_COLUMNS_MAP[field.key as keyof typeof DEFAULT_COLUMNS_MAP];
      if (['etd', 'eta'].includes(field.key) && fieldConfig) {
        return {
          ...baseConfig,
          editor: iSODateEditorWithContext,
          renderer: trackingDateRenderer,
          dateFormat: 'DD/MM/YYYY',
          correctFormat: true,
        };
      }
      if (fieldConfig) {
        return {
          ...baseConfig,
          ...fieldConfig,
          renderer: styledCellRenderer,
        };
      }

      // Default text field
      return {
        ...baseConfig,
        type: 'text',
        renderer: styledCellRenderer,
      };
    })
    .sort((a, b) => {
      const indexA = COLUMN_SORT_ORDER.indexOf(a.data as any);
      const indexB = COLUMN_SORT_ORDER.indexOf(b.data as any);
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return 0;
    });

  return [indexColumn, ...columns];
}
